import { CopyableValue, Field, FieldGrid } from '../../../common/detailParts';
import { PanelSection } from '../../PanelSection';

interface NftAddressesSectionProps {
  dappCollectionAccountAddress: string | null;
  dappReleaseAccountAddress: string | null;
  updateAuthority: string | null | undefined;
  releaseMetadataUri: string | null | undefined;
}

const explorerUrl = (address: string) =>
  `https://explorer.solana.com/address/${address}?cluster=mainnet`;

export function NftAddressesSection({
  dappCollectionAccountAddress,
  dappReleaseAccountAddress,
  updateAuthority,
  releaseMetadataUri,
}: NftAddressesSectionProps) {
  if (
    !dappCollectionAccountAddress &&
    !dappReleaseAccountAddress &&
    !updateAuthority
  ) {
    return null;
  }

  return (
    <PanelSection title="On-chain">
      <FieldGrid cols={2}>
        {dappCollectionAccountAddress && (
          <Field label="App NFT" className="sm:col-span-2">
            <CopyableValue
              value={dappCollectionAccountAddress}
              href={explorerUrl(dappCollectionAccountAddress)}
              className="-my-1.5"
            />
          </Field>
        )}
        {dappReleaseAccountAddress && (
          <Field label="Release NFT" className="sm:col-span-2">
            <CopyableValue
              value={dappReleaseAccountAddress}
              href={explorerUrl(dappReleaseAccountAddress)}
              className="-my-1.5"
            />
          </Field>
        )}
        {updateAuthority && (
          <Field label="Update authority" className="sm:col-span-2">
            <CopyableValue
              value={updateAuthority}
              href={explorerUrl(updateAuthority)}
              className="-my-1.5"
            />
          </Field>
        )}
        {releaseMetadataUri && (
          <Field label="Release metadata" className="sm:col-span-2">
            <CopyableValue
              value={releaseMetadataUri}
              href={releaseMetadataUri}
              mono={false}
              className="-my-1.5"
            />
          </Field>
        )}
      </FieldGrid>
    </PanelSection>
  );
}
